<template>
  <div>
    <v-navigation-drawer width="210px" v-model="drawer" app clipped>
      <v-list>
        <v-list-item
          v-for="(rota, indice) in rotas"
          :key="indice"
          :to="rota.path"
        >
          <v-list-item-icon>
            <v-icon>{{ rota.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title>{{ rota.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app clipped-left dark :color="$vuetify.theme.dark ? '#014991' : 'primary'">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <!-- <v-toolbar-title class="logo">Produtividade</v-toolbar-title> -->
      <img src="../../assets/img/logo-toolbar-comp.png" alt="" width="210" />

      <v-spacer></v-spacer>

      <v-divider vertical></v-divider>
      <span class="pl-4">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="v-icon-exit"
              v-bind="attrs"
              v-on="on"
              @click="toggleDarkMode"
            >{{ darkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
          </template>
          <span>{{ darkMode ? 'Modo claro' : 'Modo escuro' }}</span>
        </v-tooltip>
        <span class="icon">
          {{ usuario.login }}
        </span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="v-icon-exit mdi mdi-exit-to-app"
              v-bind="attrs"
              v-on="on"
              @click="logout"
            />
          </template>
          <span>Sair</span>
        </v-tooltip>
      </span>
    </v-app-bar>
  </div>
</template>

<script>
import utilsStorage from "@/utils/storage";
import Usuario from "../../model/usuario/Usuario";
import routes from "@/router/routes";
import { TIPO_PERFIL_USUARIO } from "@/constants/geral-constants";

export default {
  name: "Menu",
  data() {
    return {
      drawer: false,
      rotas: [],
      usuario: new Usuario(),
      darkMode: localStorage.getItem("darkMode") === "true",
    };
  },

  methods: {
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      this.$vuetify.theme.dark = this.darkMode;
      localStorage.setItem("darkMode", this.darkMode);
    },

    logout() {
      utilsStorage.removerAutenticacao();
      this.$router.push({ name: "Login" });
    },

    definirRotasDoUsuarioLogado() {
      this.usuario = new Usuario(utilsStorage.obterUsuarioAtualStorage());
      if (this.usuario.perfil.id === TIPO_PERFIL_USUARIO.ANALISTA) {
        this.rotas = routes.filter(
          (rota) => rota.menu && !rota.meta.isNotAnalista && !rota.meta.isAdmin
        );
      } else if (this.usuario.perfil.id === TIPO_PERFIL_USUARIO.ADMIN) {
        this.rotas = routes.filter((rota) => rota.menu);
      } else {
        this.rotas = routes.filter((rota) => rota.menu && !rota.meta.isAdmin);
      }
    },
  },
  mounted() {
    this.definirRotasDoUsuarioLogado();
  },
};
</script>

<style lang="scss" scoped>
.sair {
  text-transform: none;
  background-color: $white;
  border: 1px solid #dadce0;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  display: inline-block;
  letter-spacing: 0.15px;
  margin: 16px;
  outline: 0;
  padding: 10px 24px;
  text-align: center;
  text-decoration: none;
  white-space: normal;
  font-size: 12px;
  color: #5f6368;
}
.v-icon-exit {
  padding: 8px;
  border-radius: 50%;
  margin-left: 12px;
}
button:hover {
  background: #404ea7;
}
/*  mudando o menu lateral */
.v-item--active.v-list-item--active.v-list-item.v-list-item--link,
.v-list .v-list-item--active .v-icon {
  color: $cor_primaria;
}
.v-application--is-ltr
  .v-list-group--no-action
  > .v-list-group__items
  > .v-list-item {
  padding-left: 30px;
}

.v-list-item__title {
  font-size: 15px;
}
</style>
